import { render, staticRenderFns } from "./DeliveryDialog.vue?vue&type=template&id=a5a7f73c&"
import script from "./DeliveryDialog.vue?vue&type=script&lang=js&"
export * from "./DeliveryDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports